import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Sidebar, Topbar, ToastContainer, useToast } from './components/shared';
import Dashboard from './pages/Dashboard';
import { ClientiList, ClienteDetail } from './pages/Clienti';
import Scadenze, { ScadenzaDettaglio } from './pages/Scadenze';
import IVA from './pages/IVA';
import RedditiPF from './pages/RedditiPF';
import F24 from './pages/F24';
import { AvvisiList, AvvisoDetail } from './pages/Avvisi';
import { Cedenti, Cessquote } from './pages/CedentiCessquote';
import ImportRateazione from './pages/ImportRateazione';
import OneDrive from './pages/OneDrive';
import Banche from './pages/Banche';
import Attivita, { AttivitaDettaglio } from './pages/Attivita';
import Bilanci from './pages/Bilanci';
import Utenti from './pages/Utenti';
import CollegaCartelle from './pages/CollegaCartelle';
import Impostazioni from './pages/Impostazioni';
import Credenziali from './pages/Credenziali';
import Dichiarazioni from './pages/Dichiarazioni';
import { api, logout as apiLogout, getUser } from './api';

const PAGE_TITLES = {
  '/':          'Dashboard',
  '/clienti':   'Clienti',
  '/collega-cartelle': 'Collega cartelle OneDrive',
  '/scadenze':  'Scadenze',
  '/iva':       'Dichiarazioni IVA',
  '/redditi':   'Redditi',
  '/f24':       'F24 e Versamenti',
  '/avvisi':    'Avvisi e Cartelle',
  '/cedenti':   'Cedenti',
  '/cessquote': 'Cessione Quote',
  '/banche':    'Banche',
  '/attivita':  'Attività',
  '/import-rateazione': 'Import Piano Rateazione',
  '/utenti':    'Gestione Utenti',
  '/onedrive':  'Archivio Google Drive',
  '/credenziali': 'Credenziali',
  '/dichiarazioni': 'Dichiarativi',
};

function AppContent({ currentUser, onLogout }) {
  const { toasts, addToast, removeToast } = useToast();
  const [badges, setBadges] = useState({});
  const location = useLocation();

  const title = Object.entries(PAGE_TITLES)
    .sort((a, b) => b[0].length - a[0].length)
    .find(([k]) => location.pathname === k || (k !== '/' && location.pathname.startsWith(k)))?.[1] || 'Gestionale SP';

  useEffect(() => {
    api.dashboard().then(d => {
      setBadges({ clienti: d.clientiAttivi, scadenze: d.scadenzeAperte });
    }).catch(() => {});
  }, []);

  return (
    <div className="app-layout">
      <Sidebar badges={badges} currentUser={currentUser} onLogout={onLogout} />
      <div className="main-area">
        <Topbar title={title} />
        <Routes>
          <Route path="/"             element={<Dashboard addToast={addToast} />} />
          <Route path="/clienti"      element={<ClientiList addToast={addToast} />} />
          <Route path="/clienti/:id"  element={<ClienteDetail addToast={addToast} />} />
          <Route path="/collega-cartelle" element={<CollegaCartelle addToast={addToast} />} />
          <Route path="/scadenze"     element={<Scadenze addToast={addToast} />} />
          <Route path="/scadenze/:tipo/:descrizione/:data" element={<ScadenzaDettaglio addToast={addToast} />} />
          <Route path="/iva"          element={<IVA addToast={addToast} />} />
          <Route path="/redditi"      element={<RedditiPF addToast={addToast} />} />
          <Route path="/f24"          element={<F24 addToast={addToast} />} />
          <Route path="/avvisi"       element={<AvvisiList addToast={addToast} />} />
          <Route path="/avvisi/:id"   element={<AvvisoDetail addToast={addToast} />} />
          <Route path="/cedenti"      element={<Cedenti addToast={addToast} />} />
          <Route path="/cessquote"    element={<Cessquote addToast={addToast} />} />
          <Route path="/banche"       element={<Banche addToast={addToast} />} />
          <Route path="/attivita"     element={<Attivita addToast={addToast} />} />
          <Route path="/attivita/nuova" element={<AttivitaDettaglio addToast={addToast} />} />
          <Route path="/attivita/:id" element={<AttivitaDettaglio addToast={addToast} />} />
          <Route path="/import-rateazione" element={<ImportRateazione addToast={addToast} />} />
          <Route path="/bilanci" element={<Bilanci addToast={addToast} />} />
          <Route path="/bilanci/:id" element={<Bilanci addToast={addToast} />} />
          <Route path="/onedrive"     element={<OneDrive addToast={addToast} />} />
          <Route path="/credenziali"  element={<Credenziali addToast={addToast} />} />
          <Route path="/dichiarazioni" element={<Dichiarazioni addToast={addToast} />} />
          <Route path="/dichiarazioni/:tipo" element={<Dichiarazioni addToast={addToast} />} />
          <Route path="/dichiarazioni/:tipo/:id" element={<Dichiarazioni addToast={addToast} />} />
          {currentUser?.ruolo === 'admin' && (
            <Route path="/utenti" element={<Utenti addToast={addToast} currentUser={currentUser} />} />
          )}
          <Route path="/impostazioni" element={<Impostazioni addToast={addToast} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </div>
  );
}

// ─── LOGIN ────────────────────────────────────────────────────────────────────
function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const data = await api.login({ username, password });
      localStorage.setItem('sp_token', data.token);
      localStorage.setItem('sp_user', JSON.stringify(data.user));
      onLogin(data.user);
    } catch(e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'var(--bg)' }}>
      <div style={{ width:360, background:'var(--surface)', border:'1px solid var(--border)',
        borderRadius:'var(--radius)', padding:'32px 28px', boxShadow:'0 4px 24px rgba(0,0,0,0.08)' }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:22, fontWeight:800, color:'var(--text)' }}>Studio SP</div>
          <div style={{ fontSize:13, color:'var(--text-faint)', marginTop:4 }}>Gestionale — Accedi</div>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:12, fontWeight:600, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Username</label>
            <input className="form-control" value={username} onChange={e=>setUsername(e.target.value)}
              required autoFocus placeholder="username" />
          </div>
          <div style={{ marginBottom:18 }}>
            <label style={{ fontSize:12, fontWeight:600, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Password</label>
            <input className="form-control" type="password" value={password} onChange={e=>setPassword(e.target.value)}
              required placeholder="••••••••" />
          </div>
          {error && <div style={{ padding:'8px 12px', background:'#FEF2F2', border:'1px solid #FECACA',
            borderRadius:6, color:'#DC2626', fontSize:12, marginBottom:14 }}>⚠ {error}</div>}
          <button type="submit" className="btn btn-primary" style={{ width:'100%' }} disabled={loading}>
            {loading ? '⏳ Accesso…' : 'Accedi'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default function App() {
  const [currentUser, setCurrentUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('sp_user')); } catch(e) { return null; }
  });

  const handleLogin = (user) => setCurrentUser(user);

  const handleLogout = () => {
    localStorage.removeItem('sp_token');
    localStorage.removeItem('sp_user');
    setCurrentUser(null);
  };

  if (!currentUser || !localStorage.getItem('sp_token')) {
    return <BrowserRouter><Login onLogin={handleLogin} /></BrowserRouter>;
  }

  return (
    <BrowserRouter>
      <AppContent currentUser={currentUser} onLogout={handleLogout} />
    </BrowserRouter>
  );
}
